import React from 'react';

import {
  Box,
  Typography,
  Dialog,
  MaterialIcons,
  MaterialUICore,
} from '@iclinic/design-system';

const { IconButton } = MaterialUICore;
const { Close } = MaterialIcons;

interface HeaderDialogProps {
  open: boolean;
  title: string;
  observation: string;
  onClose: () => void;
}
export const HeaderDialog = ({
  open,
  title,
  observation,
  onClose,
}: HeaderDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    title={`Detalhe ${title}`}
  >
    <Box mx={3} mt={2} mb={4} width="760px">
      <Box display="flex" justifyContent="right">
        <IconButton size="small" title={`Fechar ${title}`} onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <Box mb={1}>
        <Typography variant="body2" bold>
          {title}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="textPrimary">
          {observation}
        </Typography>
      </Box>
    </Box>
  </Dialog>
);
